module.exports = __webpack_public_path__ + "8d165188896bfed32176b75d97f2b424.png";